import React, { Component } from 'react';
import './css/homepage.css';
import './css/category.css';
import baseUrl from './constants/config'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import ReactGA from 'react-ga';


class Category extends Component {
  constructor (props) {
    super(props)
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    
    return (
      <div className="Homepage">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <header className="Homepage-header">
            <title>FGO Trivia Question Categories</title>
            <meta NAME="Description" CONTENT="Play the Fate Grand Order (FGO) trivia game. Answer questions from different categories such as servant pictures, bond craft essences, servant quotes, noble phantasms, and many more. "/>
            <h1 className="Homepage-title">FGO Trivia Categories</h1>
          </header>
        </Link>
        <Link to="/servantpicture" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <img className="categoryImage"
                src={'https://doigrgvizfuvs.cloudfront.net/assets/Attila_pic1-body.png'} 
                alt='Attila body pic'/>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you know your servant pictures well? Identify them by the picture!</p>
            </div>
          </div>
        </Link>

        <Link to="/craftessence" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <img className="categoryImage"
                src={'https://doigrgvizfuvs.cloudfront.net/assets/DaVinci_Craft_Essence.png'} 
                alt='Attila body pic'/>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you have a bond level 10 Da Vinci yet? Identify servants by their craft essences!</p>
            </div>
          </div>
        </Link>

        <Link to="/bio" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <p>"Ah... Don't stare at me so hard. It makes me want to remove your bones, melt you into a nice red wine, and drink you all up..."</p>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you talk to your servants? Do you know their back stories? Identify them!</p>
            </div>
          </div>
        </Link>

        <Link to="/sprite" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <img className="categoryImage"
                src={'https://doigrgvizfuvs.cloudfront.net/assets/Jack_the_Ripper_sprite.png'} 
                alt='Jack the ripper sprite pic'/>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you know your servant's sprite? Who is this?</p>
            </div>
          </div>
        </Link>

        <Link to="/item" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <img className="categoryImage"
                src={'https://doigrgvizfuvs.cloudfront.net/assets/Mysterious_Heroine_X_swords.png'} 
                alt='Mysterious Heroine X MHX swords'/>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you know what your servant carries around and fights with? Who uses these swords?</p>
            </div>
          </div>
        </Link>

        <Link to="/valentines" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <img className="categoryImage"
                src={'https://doigrgvizfuvs.cloudfront.net/assets/Orion_Chocolate.jpg'} 
                alt='Orion Valentines Chocolate'/>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you know the chocolates that your servants gave you on Valentines Day?</p>
            </div>
          </div>
        </Link>


        <Link to="/noblephantasm" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <p>Rule Breaker</p>
              <p>Golden Spark</p>
              <p>Smile of Stheno</p>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you know who use these noble phantasms? Identify them!</p>
            </div>
          </div>
        </Link>

        <Link to="/shoes" style={{ textDecoration: 'none' }}>
          <div className="categoryRow">
            <div className="imageWrapper">
              <img className="categoryImage"
                src={'https://doigrgvizfuvs.cloudfront.net/assets/Mashu_Kyrielight_Shoes.png'} 
                alt='Mash Kyrielight Shoes'/>
            </div>
            <div className="rightContainer">
              <p className="textDescription">Do you know what shoes your servants wear?</p>
            </div>
          </div>
        </Link>

      </div>
    );
  }
}

export default Category;



// WEBPACK FOOTER //
// ./src/components/category.js